import { render, staticRenderFns } from "./BlockForm.vue?vue&type=template&id=ddd4a374&scoped=true&"
import script from "./BlockForm.vue?vue&type=script&lang=js&"
export * from "./BlockForm.vue?vue&type=script&lang=js&"
import style0 from "./BlockForm.vue?vue&type=style&index=0&id=ddd4a374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd4a374",
  null
  
)

export default component.exports